import React from 'react'
interface Props {
  message?: string
  icon?: any
}
export const MsgAlert = (props: Props) => {
  return (
    <div {...props} className="message-alert icon-text">
      <span className="icon">{props.icon}</span>
      <span className="desc c-darkblue">{props.message}</span>
    </div>
  )
}
